import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import {
  Box,
  Container,
  makeStyles,
  Typography,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Button as Botao,
  ButtonBase,
  Menu,
  MenuItem,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import Page from 'src/components/Page';
import moment from 'moment';
import AttachFile from '@material-ui/icons/AttachFile';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import Input from '../../../shared/component/FormElements/Input';
import Destaque from '../../../shared/component/FormElements/Destaque';
import Chips from '../../../shared/component/FormElements/Chips';
import Button from '../../../shared/component/FormElements/Button';
import Seletor from '../../../shared/component/FormElements/Seletor';
import ErrorMessage from '../../../shared/component/UIElements/ErrorMessage';
import LoadingSpinner from '../../../shared/component/UIElements/LoadingSpinner';
import {
  VALIDATOR_REQUIRE,
} from '../../../utils/validators';
import { useForm } from '../../../hooks/form-hook';
import { useHttpClient } from '../../../hooks/http-hook';
import { AuthContext } from '../../../shared/context/auth-context';

import UploadAnexo from '../components/UploadAnexo';
import UploadGaleria from '../components/UploadGaleria';
import Anexo from '../components/Anexo';
import Autocomplete from '../components/Autocomplete';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  titulo: {
    color: '#3E3E3E',
    fontWeight: 500,
    fontSize: '33px',
    marginBottom: '16px'
  },
  button: {
    marginTop: '15px',
    color: 'white',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    width: '100%'
  },
  header: {
    backgroundColor: '#2C3E50',
    color: 'white',
    fontFamily: 'Roboto',
    fontWeight: 500,
    textAlign: 'center'
  },
  galeria: {
    marginTop: '32px'
  },
  data: {
    color: '#828282',
    fontSize: '14px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    display: 'block',
    width: '100%'
  },
  valor: {
    color: '#828282',
    fontSize: '18px',
    fontFamily: 'Roboto',
    fontWeight: 400,
    display: 'block',
    width: '100%',
    paddingTop: '20px',
    paddingBottom: '20px',
  },
  nome: {
    '& input': {
      color: '#3E3E3E',
      fontWeight: 500,
      fontSize: '33px',
    },
    '& fieldset': {
      border: 'none'
    }
  },
  mais: {
    width: '100%',
    height: '87px',
    display: 'flex',
    backgroundColor: '#F3F3F3',
    overflow: 'hidden'
  },
  icone: {
    fontSize: '50px',
    color: '#ACACAC'
  },
  listItem: {
    color: '#808080',
    fontSize: '14px',
    lineHeight: '14px',
    fontFamily: 'Roboto',
    verticalAlign: 'top'
  },
  remover: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    color: '#808080',
    textAlign: 'center',
    maxWidth: '290px',
    margin: '15px auto'
  },
  removerholder: {
    overflowY: 'unset',
    textAlign: 'center',
    padding: '24px'
  },
  sim: {
    color: 'white',
    display: 'inline-block',
    padding: '6px 16px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    margin: '5px 15px',
    background: '#C03A2A',
    '&:hover': {
      backgroundColor: '#C03A2A',
    },
    maxWidth: '112px'
  },
  nao: {
    color: 'white',
    display: 'inline-block',
    padding: '6px 16px',
    margin: '5px 15px',
    borderRadius: '23px',
    WebkitBorderRadius: '23px',
    MozBorderRadius: '23px',
    background: '#808080',
    '&:hover': {
      backgroundColor: '#808080',
    },
    maxWidth: '112px'
  }
}));

const Editar = () => {
  const classes = useStyles();
  const auth = useContext(AuthContext);
  const [doadores, setDoadores] = useState([]);
  const [doador, setDoador] = useState(false);
  const [acervo, setAcervo] = useState(null);
  const [situacoes, setSituacoes] = useState([]);
  const [classificacoes, setClassificacoes] = useState([]);
  const [procedencias, setProcedencias] = useState([]);
  const [salas, setSalas] = useState([]);
  const [moveis, setMoveis] = useState([]);
  const [nichos, setNichos] = useState([]);
  const [arqs, setArqs] = useState([]);
  const [navegar, setNavegar] = useState(false);
  const [remover, setRemover] = useState(false);
  const [modalAnexo, setModalAnexo] = useState(false);
  const [modalGaleria, setModalGaleria] = useState(false);
  const [anexos, setAnexos] = useState([]);
  const [galerias, setGalerias] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [imagem, setImagem] = useState(null);
  const [selected, setSelected] = useState([]);
  const id = useParams().id;
  console.log(imagem);
  const {
    isLoading,
    error,
    sendRequest,
    clearError
  } = useHttpClient();
  const [formState, inputHandler, setFormData] = useForm({
    nome: {
      value: '',
      isValid: false
    },
    destaque: {
      value: '',
      isValid: true
    },
    status: {
      value: '',
      isValid: false
    },
    situacao: {
      value: '',
      isValid: false
    },
    doador: {
      value: '',
      isValid: true
    },
    data: {
      value: '',
      isValid: false
    },
    tags: {
      value: '',
      isValid: false
    },
    altura: {
      value: '',
      isValid: false
    },
    largura: {
      value: '',
      isValid: false
    },
    profundidade: {
      value: '',
      isValid: false
    },
    peso: {
      value: '',
      isValid: false
    },
    descricao: {
      value: '',
      isValid: false
    },
    sala: {
      value: '',
      isValid: false
    },
    movel: {
      value: '',
      isValid: true
    },
    nicho: {
      value: '',
      isValid: true
    },
    arq: {
      value: '',
      isValid: true
    },
    num_inventario: {
      value: '',
      isValid: false
    },
    data_atribuida: {
      value: '',
      isValid: false
    },
    classificacao: {
      value: '',
      isValid: false
    },
    procedencia: {
      value: '',
      isValid: false
    },
  }, false);
  const novoSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      const formulario = new FormData();
      formulario.append('nome', formState.inputs.nome.value);
      formulario.append('destaque', formState.inputs.destaque.value);
      formulario.append('doador', formState.inputs.doador.value);
      formulario.append('data', formState.inputs.data.value);
      formulario.append('tags', formState.inputs.tags.value);
      formulario.append('status', formState.inputs.status.value);
      formulario.append('situacao', formState.inputs.situacao.value);
      formulario.append('altura', formState.inputs.altura.value);
      formulario.append('largura', formState.inputs.largura.value);
      formulario.append('profundidade', formState.inputs.profundidade.value);
      formulario.append('peso', formState.inputs.peso.value);
      formulario.append('descricao', formState.inputs.descricao.value);
      formulario.append('sala', formState.inputs.sala.value);
      formulario.append('movel', formState.inputs.movel.value);
      formulario.append('nicho', formState.inputs.nicho.value);
      formulario.append('arq', formState.inputs.arq.value);
      formulario.append('anexos', anexos.map((a) => a._id));
      formulario.append('galeria', galerias.map((a) => a._id));
      formulario.append('num_inventario', formState.inputs.num_inventario.value);
      formulario.append('data_atribuida', formState.inputs.data_atribuida.value);
      formulario.append('classificacao', formState.inputs.classificacao.value);
      formulario.append('procedencia', formState.inputs.procedencia.value);
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/acervos/${id}`,
        'PUT',
        formulario,
        {
          'x-access-token': auth.token
        }
      );
      console.log(response);
      if (response.sucesso) {
        setNavegar('app/acervos/');
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const fetchDoadores = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/doadores`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setDoadores(responseData.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchDoadores();
  }, [auth]);

  useEffect(() => {
    const fetchSalas = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/mapas`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setSalas(responseData.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchSalas();
  }, [auth]);

  useEffect(() => {
    const fetchSituacoes = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/situacoes`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setSituacoes(responseData.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchSituacoes();
  }, [auth]);

  useEffect(() => {
    const fetchClassificacoes = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/classificacoes`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setClassificacoes(responseData.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchClassificacoes();
  }, [auth]);
  useEffect(() => {
    const fetchProcedencias = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/procedencias`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log(responseData);
        setProcedencias(responseData.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchProcedencias();
  }, [auth]);

  useEffect(() => {
    const fetchAcervo = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/acervos/${id}`,
          'GET',
          null,
          {
            'Content-Type': 'application/json',
            'x-access-token': auth.token
          }
        );
        console.log('Acervo');
        console.log(responseData.data);
        const historico = responseData.data.history.reverse();
        responseData.data.history = historico;
        setAcervo(responseData.data);
        setGalerias(responseData.data.galeria);
        setAnexos(responseData.data.anexos);
        setDoador(responseData.data.doador);
        if (responseData.data.sala) {
          const salaf = salas.filter((s) => s._id === responseData.data.sala._id);
          if (salaf.length > 0) {
            setMoveis(salaf[0].moveis);
            const movs = salaf[0].moveis;
            if (responseData.data.movel) {
              const movel = movs.filter((m) => m._id === responseData.data.movel._id);
              if (movel.length > 0) {
                setNichos(movel[0].nichos);
                if (responseData.data.nicho) {
                  const nichs = movel[0].nichos;
                  const nicho = nichs.filter((n) => n._id === responseData.data.nicho._id);
                  if (nicho.length > 0) {
                    setArqs(nicho[0].arquivos);
                  } else {
                    setArqs([]);
                  }
                }
              } else {
                setNichos([]);
              }
            }
          } else {
            setMoveis([]);
          }
        }
      } catch (err) {
        console.log(err);
      }
    };
    if (salas.length > 0) {
      fetchAcervo();
    }
  }, [auth, id, salas]);
  const status = ['Ruim', 'Regular', 'Bom'];

  const controlaAnexos = async () => {
    setModalAnexo(!modalAnexo);
  };

  const controlaGalerias = async () => {
    setModalGaleria(!modalGaleria);
  };

  const confirmar = async (anex) => {
    setModalAnexo(false);
    console.log('Anexos enviados: ');
    console.log(anex);
    setAnexos((prevState) => prevState.concat(anex.filter((a) => a.criado).map((a) => a.criado)));
  };

  const confirmarGalerias = async (gal) => {
    setModalGaleria(false);
    console.log('Imagens enviadas: ');
    console.log(gal);
    setGalerias((prevState) => prevState.concat(gal.filter((a) => a.criado).map((a) => a.criado)));
  };

  const handleMoveis = (sala) => {
    const salaf = salas.filter((s) => s._id === sala);
    if (salaf.length > 0) {
      setMoveis(salaf[0].moveis);
    } else {
      setMoveis([]);
    }
  };

  const handleNichos = (mov) => {
    const movel = moveis.filter((m) => m._id === mov);
    if (movel.length > 0) {
      setNichos(movel[0].nichos);
    } else {
      setNichos([]);
    }
  };

  const handleArq = (nich) => {
    const nicho = nichos.filter((n) => n._id === nich);
    if (nicho.length > 0) {
      setArqs(nicho[0].arquivos);
    } else {
      setArqs([]);
    }
  };

  const handleGaleria = (event, gal) => {
    setAnchorEl(event.currentTarget);
    setImagem(gal);
  };

  const handleGaleriaClose = () => {
    setImagem(null);
    setAnchorEl(null);
  };

  // Handle Selected Anexos

  const abreRemove = (event, arqvs) => {
    setRemover(arqvs);
  };

  const fechaRemover = async () => {
    setRemover(false);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleConfirmarRemove = (rmv) => {
    if (Array.isArray(rmv)) {
      setAnexos((prevState) => {
        const data = [...prevState.filter((item) => !rmv.includes(item.original))];
        return data;
      });
    } else {
      const paraRemover = anexos.indexOf(rmv);
      if (paraRemover !== -1) {
        setAnexos((prevState) => {
          const data = [...prevState.filter((item) => item !== rmv)];
          return data;
        });
      }
    }
    setRemover(false);
    setSelected([]);
  };

  const mudaDoador = async (d) => {
    console.log('Novo doador');
    console.log(d);
    console.log(formState.isValid);
    setFormData(
      {
        ...formState.inputs,
        doador: {
          value: d !== null ? d._id : '',
          isValid: d !== null
        },
      },
      formState.isValid
    );
    setDoador(d);
  };

  if (navegar) {
    return <Navigate to={`/${navegar}`} />;
  }
  if ((isLoading && !acervo) || situacoes.length === 0 || doadores.length === 0 || classificacoes.length === 0 || procedencias.length === 0) {
    return (
      <Page
        className={classes.root}
        title="Editando item"
      >
        <Container maxWidth="xl">
          <LoadingSpinner asOverlay />
        </Container>
      </Page>
    );
  }

  return (
    <Page
      className={classes.root}
      title="Editando item"
    >
      {acervo && situacoes.length > 0 && classificacoes.length > 0 && procedencias.length > 0 && doador !== false && (
        <Container maxWidth="xl">
          <form onSubmit={novoSubmitHandler}>
            <Grid container>
              <Grid item xs={6}>
                <Input
                  id="nome"
                  element="input"
                  type="text"
                  fullWidth
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText="Insira um nome."
                  onInput={inputHandler}
                  placeholder="Nome do Item"
                  variant="outlined"
                  initialValid
                  initialValue={acervo.nome}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end"><EditIcon /></InputAdornment>
                  }}
                  extraClass={classes.nome}
                />
              </Grid>
            </Grid>
            <Grid container spacing={5}>
              <Grid item xs={4} xl={4} lg={4} md={6} sm={12}>
                <Card>
                  <CardHeader
                    className={classes.header}
                    title="Fotografia Principal"
                  />
                  <CardContent>
                    <Destaque
                      id="destaque"
                      name="destaque"
                      onInput={inputHandler}
                      validators={[]}
                      initialValid
                      initialValue={acervo.destaque !== undefined ? `${process.env.REACT_APP_BACKEND_IMG}${acervo.destaque.caminho}` : ''}
                      errorText="Insira o avatar do usuário."
                      label="Avatar do Usuário"
                    />
                  </CardContent>
                </Card>
                <Card
                  className={classes.galeria}
                >
                  <CardHeader
                    className={classes.header}
                    title="Galeria de Fotos"
                  />
                  <CardContent>
                    <Grid container spacing={2}>
                      {galerias.map((gal) => (
                        <Grid item xs={4}>
                          <ButtonBase
                            className={classes.mais}
                            onClick={(event) => handleGaleria(event, gal._id)}
                          >
                            <img src={`${process.env.REACT_APP_BACKEND_IMG}${gal.caminho}`} alt="aa" />
                          </ButtonBase>
                        </Grid>
                      ))}
                      <Grid item xs={4}>
                        <ButtonBase
                          className={classes.mais}
                          onClick={() => setModalGaleria(true)}
                        >
                          <AddIcon
                            className={classes.icone}
                          />
                        </ButtonBase>
                      </Grid>
                    </Grid>
                    <Menu
                      id="simple-galeria-imagem"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleGaleriaClose}
                    >
                      <MenuItem>Remover Imagem</MenuItem>
                    </Menu>
                  </CardContent>
                </Card>
                <Card
                  className={classes.galeria}
                >
                  <CardHeader
                    className={classes.header}
                    title="Histórico do Item"
                  />
                  <CardContent>
                    <List
                      component="nav"
                      disablePadding
                      aria-label="historico"
                    >
                      {acervo.history.map((h) => (
                        <ListItem
                          style={{ alignItems: 'flex-start' }}
                        >
                          <ListItemText
                            className={classes.listItem}
                            style={{ maxWidth: '100px', marginRight: '30px' }}
                          >
                            {moment(h.time).format('DD/MM/YYYY HH:mm')}
                          </ListItemText>
                          <ListItemText
                            className={classes.listItem}
                          >
                            {h.status}
                          </ListItemText>
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={8} xl={8} lg={8} md={6} sm={12}>
                <Card>
                  <CardHeader
                    className={classes.header}
                    style={{ textAlign: 'left' }}
                    title="Informações Principais"
                  />
                  <CardContent>
                    <Box mt={3}>
                      <Box my={2}>
                        <Grid container spacing={2}>
                          <Grid item xs={2}>
                            <Typography
                              color="textPrimary"
                              align="left"
                              variant="span"
                              className={classes.data}
                            >
                              Data de Registro
                            </Typography>
                            <Typography
                              color="textPrimary"
                              align="left"
                              variant="span"
                              className={classes.valor}
                            >
                              {`${moment(acervo.createdDate).format('DD/MM/YYYY hh:mm')}`}
                            </Typography>
                          </Grid>
                          <Grid item xs={10}>
                            <Input
                              id="num_inventario"
                              element="input"
                              type="text"
                              label="Número do Inventário"
                              fullWidth
                              validators={[VALIDATOR_REQUIRE()]}
                              initialValid
                              initialValue={acervo.num_inventario}
                              errorText="Insira o número do Inventário Arquitetonico."
                              onInput={inputHandler}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Autocomplete
                              opcoes={doadores.map((d) => ({
                                documento: d.documento,
                                nome: d.nome,
                                tipo: d.tipo,
                                _id: d._id
                              }))}
                              selecionado={doador}
                              id="seletordoador"
                              label="Pesquisar Doador"
                              fullWidth
                              variant="outlined"
                              onChange={mudaDoador}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          {(doador !== null && doador !== undefined) && (
                            <>
                              <Grid item xs={4}>
                                <Typography
                                  color="textPrimary"
                                  align="left"
                                  variant="span"
                                  className={classes.data}
                                >
                                  Nome do Doador
                                </Typography>
                                <Typography
                                  color="textPrimary"
                                  align="left"
                                  variant="span"
                                  className={classes.valor}
                                >
                                  {doador.nome}
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography
                                  color="textPrimary"
                                  align="left"
                                  variant="span"
                                  className={classes.data}
                                >
                                  Tipo do Documento
                                </Typography>
                                <Typography
                                  color="textPrimary"
                                  align="left"
                                  variant="span"
                                  className={classes.valor}
                                >
                                  {doador.tipo}
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography
                                  color="textPrimary"
                                  align="left"
                                  variant="span"
                                  className={classes.data}
                                >
                                  Documento
                                </Typography>
                                <Typography
                                  color="textPrimary"
                                  align="left"
                                  variant="span"
                                  className={classes.valor}
                                >
                                  {doador.documento}
                                </Typography>
                              </Grid>
                            </>
                          )}
                          <Grid item xs={4}>
                            <Input
                              id="data"
                              element="input"
                              type="date"
                              label="Data de Doação"
                              fullWidth
                              format="MM/dd/yyyy"
                              validators={[VALIDATOR_REQUIRE()]}
                              errorText="Insira uma data de doação válida."
                              onInput={inputHandler}
                              initialValid
                              initialValue={moment(acervo.data).format('YYYY-MM-DD')}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <Input
                              id="data_atribuida"
                              element="input"
                              type="date"
                              label="Data Atribuida"
                              fullWidth
                              format="MM/dd/yyyy"
                              initialValid
                              initialValue={acervo.data_atribuida}
                              validators={[VALIDATOR_REQUIRE()]}
                              errorText="Insira uma data de doação válida."
                              onInput={inputHandler}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <Seletor
                              id="status"
                              name="status"
                              onInput={inputHandler}
                              label="Estado de Conservação"
                              placeholder="Estado de Conservação"
                              blank="Selecione"
                              fullWidth
                              variant="outlined"
                              data={status.map((s) => {
                                return { label: s, id: s };
                              })}
                              initialValid
                              initialValue={acervo.status}
                              errorText="Informe o estado de conservação do item."
                              validators={[VALIDATOR_REQUIRE()]}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Seletor
                              id="situacao"
                              name="situacao"
                              onInput={inputHandler}
                              label="Situação"
                              placeholder="Situação"
                              blank="Selecione"
                              fullWidth
                              variant="outlined"
                              data={situacoes.map((s) => {
                                return { label: s.nome, id: s._id };
                              })}
                              initialValid
                              initialValue={acervo.situacao ? acervo.situacao._id : ''}
                              errorText="Informe a situação do item."
                              validators={[VALIDATOR_REQUIRE()]}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Seletor
                              id="classificacao"
                              name="classificacao"
                              onInput={inputHandler}
                              label="Classificação"
                              placeholder="Classificação"
                              blank="Selecione"
                              fullWidth
                              variant="outlined"
                              data={classificacoes.map((s) => {
                                return { label: s.nome, id: s._id };
                              })}
                              initialValid
                              initialValue={acervo.classificacao ? acervo.classificacao._id : ''}
                              errorText="Informe a classificação do item."
                              validators={[VALIDATOR_REQUIRE()]}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Seletor
                              id="procedencia"
                              name="procedencia"
                              onInput={inputHandler}
                              label="Procedência"
                              placeholder="Procedência"
                              blank="Selecione"
                              fullWidth
                              variant="outlined"
                              data={procedencias.map((s) => {
                                return { label: s.nome, id: s._id };
                              })}
                              initialValid
                              initialValue={acervo.procedencia ? acervo.procedencia._id : ''}
                              errorText="Informe a procedencia do item."
                              validators={[VALIDATOR_REQUIRE()]}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Chips
                              id="tags"
                              name="tags"
                              onInput={inputHandler}
                              label="Tags"
                              placeholder="Tags"
                              fullWidth
                              variant="outlined"
                              initialValid
                              initialValue={acervo.tags}
                              errorText="Informe a situação do item."
                              validators={[]}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Divider variant="middle" style={{ margin: '30px 0px' }} />
                        <Grid container spacing={2}>
                          <Grid item xs={moveis.length > 0 ? 3 : 12}>
                            <Seletor
                              id="sala"
                              name="sala"
                              onInput={inputHandler}
                              label="Sala do Acervo"
                              placeholder="Sala do Acervo"
                              blank="Selecione a Sala do Acervo"
                              fullWidth
                              variant="outlined"
                              data={salas.map((sala) => {
                                return { label: sala.nome, id: sala._id };
                              })}
                              initialValid
                              initialValue={acervo.sala ? acervo.sala._id : ''}
                              errorText="Selecione a Sala do Acervo."
                              validators={[VALIDATOR_REQUIRE()]}
                              onChange={handleMoveis}
                            />
                          </Grid>
                          {moveis.length > 0 && (
                            <Grid item xs={3}>
                              <Seletor
                                id="movel"
                                name="movel"
                                onInput={inputHandler}
                                label="Móvel do Acervo"
                                placeholder="Móvel do Acervo"
                                blank="Selecione o Móvel do Acervo"
                                fullWidth
                                variant="outlined"
                                initialValid
                                initialValue={acervo.movel ? acervo.movel._id : ''}
                                data={moveis.map((n) => {
                                  return { label: n.nome, id: n._id };
                                })}
                                errorText="Selecione o Móvel do Acervo."
                                validators={[]}
                                onChange={handleNichos}
                              />
                            </Grid>
                          )}
                          {nichos.length > 0 && (
                            <Grid item xs={3}>
                              <Seletor
                                id="nicho"
                                name="nicho"
                                onInput={inputHandler}
                                label="Nicho do Acervo"
                                placeholder="Nicho do Acervo"
                                blank="Selecione o Nicho do Acervo"
                                fullWidth
                                initialValid
                                initialValue={acervo.nicho ? acervo.nicho._id : ''}
                                variant="outlined"
                                data={nichos.map((n) => {
                                  return { label: n.nome, id: n._id };
                                })}
                                errorText="Selecione o Nicho do Acervo."
                                validators={[]}
                                onChange={handleArq}
                              />
                            </Grid>
                          )}
                          {arqs.length > 0 && (
                            <Grid item xs={3}>
                              <Seletor
                                id="arq"
                                name="arq"
                                onInput={inputHandler}
                                label="Arquivo do Acervo"
                                placeholder="Arquivo do Acervo"
                                blank="Selecione o Arquivo do Acervo"
                                fullWidth
                                initialValid
                                initialValue={acervo.arq ? acervo.arq._id : ''}
                                variant="outlined"
                                data={arqs.map((n) => {
                                  return { label: n.nome, id: n._id };
                                })}
                                errorText="Selecione o Arquivo do Acervo."
                                validators={[]}
                              />
                            </Grid>
                          )}
                        </Grid>
                        <Divider variant="middle" style={{ margin: '30px 0px' }} />
                        <Grid container spacing={2}>
                          <Grid item xs={3}>
                            <Input
                              id="altura"
                              element="input"
                              type="text"
                              label="Altura"
                              fullWidth
                              validators={[VALIDATOR_REQUIRE()]}
                              errorText="Insira uma altura."
                              onInput={inputHandler}
                              initialValid
                              initialValue={acervo.medidas.altura}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                            <Input
                              id="largura"
                              element="input"
                              type="text"
                              label="Largura"
                              fullWidth
                              validators={[VALIDATOR_REQUIRE()]}
                              errorText="Insira uma largura."
                              onInput={inputHandler}
                              initialValid
                              initialValue={acervo.medidas.largura}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                            <Input
                              id="profundidade"
                              element="input"
                              type="text"
                              label="Profundidade"
                              fullWidth
                              validators={[VALIDATOR_REQUIRE()]}
                              errorText="Insira uma profundidade."
                              onInput={inputHandler}
                              initialValid
                              initialValue={acervo.medidas.profundidade}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                            <Input
                              id="peso"
                              element="input"
                              type="text"
                              label="Peso"
                              fullWidth
                              validators={[VALIDATOR_REQUIRE()]}
                              errorText="Insira um peso."
                              onInput={inputHandler}
                              initialValid
                              initialValue={acervo.peso}
                              variant="outlined"
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item xs={9}>
                            <Input
                              id="descricao"
                              element="input"
                              type="textarea"
                              label="Descrição / Histórico da Peça"
                              fullWidth
                              validators={[VALIDATOR_REQUIRE()]}
                              errorText="Insira um nome."
                              onInput={inputHandler}
                              initialValid
                              initialValue={acervo.descricao}
                              variant="outlined"
                              rows={13}
                              multiline
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          spacing={2}
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                        >
                          {(auth.userPermission.permissoes.includes('anexos') || auth.userPermission.nome === 'Gestor do Sistema') && (
                            <Grid item xs={3}>
                              <Botao
                                color="secondary"
                                variant="contained"
                                size="large"
                                onClick={controlaAnexos}
                                startIcon={<AttachFile />}
                                className={classes.button}
                              >
                                ANEXAR ARQUIVOS
                              </Botao>
                            </Grid>
                          )}
                          <Grid item xs={3}>
                            <Button
                              color="secondary"
                              disabled={!formState.isValid}
                              size="large"
                              type="submit"
                              variant="contained"
                              marginBottom={5}
                              classes={classes.button}
                            >
                              Salvar
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                      {isLoading && <LoadingSpinner asOverlay />}
                      <ErrorMessage error={error} onClear={clearError} />
                    </Box>
                  </CardContent>
                </Card>
                <Card
                  style={{ marginTop: '32px' }}
                >
                  <CardHeader
                    className={classes.header}
                    style={{ textAlign: 'left' }}
                    title="Anexos"
                  />
                  <CardContent>
                    <Box mt={3}>
                      <Box my={2}>
                        <Grid container spacing={2}>
                          {anexos.map((anexo) => <Anexo anexo={anexo} onChecked={handleClick} selected={selected} podeRemover={auth.userPermission.permissoes.includes('anexos') || auth.userPermission.nome === 'Gestor do Sistema'} onRemoveConfirma={handleConfirmarRemove} />)}
                        </Grid>
                        {selected.length > 0 && (
                          <Grid
                            container
                            style={{ marginTop: '20px' }}
                          >
                            <Grid item xs={6}>
                              <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
                                {`${selected.length} selecionado(s)`}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              style={{ textAlign: 'right' }}
                            >
                              <Tooltip title="Delete">
                                <IconButton
                                  style={{ padding: '0px' }}
                                  aria-label="delete"
                                  onClick={(event) => abreRemove(event, selected)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </Grid>
                          </Grid>
                        )}
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </form>
        </Container>
      )}
      <Dialog
        open={remover !== false}
        onClose={fechaRemover}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent className={classes.removerholder}>
          <Typography className={classes.remover} color="inherit" variant="subtitle1" component="div">
            Tem certeza que deseja excluir os anexos selecionados?
          </Typography>
          <Botao
            fullWidth
            marginBottom={5}
            onClick={fechaRemover}
            classes={{
              root: classes.nao
            }}
          >
            NÃO
          </Botao>
          <Botao
            fullWidth
            marginBottom={5}
            onClick={() => handleConfirmarRemove(selected)}
            classes={{
              root: classes.sim
            }}
          >
            SIM
          </Botao>
        </DialogContent>
      </Dialog>
      <UploadAnexo open={modalAnexo} confirmar={confirmar} onClose={controlaAnexos} />
      <UploadGaleria open={modalGaleria} confirmar={confirmarGalerias} onClose={controlaGalerias} />
    </Page>
  );
};
export default Editar;
